var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBestInterestRatesFinancing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#323232"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2535 10.3032C39.7248 10.3032 40.1068 9.89021 40.1068 9.38082C40.1068 8.87144 39.7248 8.4585 39.2535 8.4585C38.7822 8.4585 38.4001 8.87144 38.4001 9.38082C38.4001 9.89021 38.7822 10.3032 39.2535 10.3032Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 51.8081C25.5703 51.8081 38.7059 51.8081 51.2001 51.8081",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2131 51.8081C16.2131 46.3286 16.2131 44.539 16.2402 39.245C18.3003 38.7632 21.9771 38.9198 24.7465 38.9198C24.6249 45.5723 24.7465 45.7144 24.7465 51.6612",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1599 51.8083C28.1599 46.6198 28.1599 36.8586 28.1842 31.8412C30.0363 31.3987 33.3475 31.5378 35.8399 31.5378C35.7305 37.8347 35.8399 46.036 35.8399 51.6692",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2534 51.8078C39.2534 46.5442 39.2534 24.946 39.2827 19.8582C41.3395 19.4094 45.0166 19.5459 47.7868 19.5459C47.6607 25.9363 47.7868 45.9519 47.7868 51.6667",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0667 31.5172L28.7076 23.1235L39.2533 9.38135",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.92 31.5165C18.3913 31.5165 18.7733 31.1036 18.7733 30.5942C18.7733 30.0848 18.3913 29.6719 17.92 29.6719C17.4487 29.6719 17.0667 30.0848 17.0667 30.5942C17.0667 31.1036 17.4487 31.5165 17.92 31.5165Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0132 24.1381C29.4845 24.1381 29.8666 23.7252 29.8666 23.2158C29.8666 22.7064 29.4845 22.2935 29.0132 22.2935C28.542 22.2935 28.1599 22.7064 28.1599 23.2158C28.1599 23.7252 28.542 24.1381 29.0132 24.1381Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestInterestRatesFinancing);
export default __webpack_public_path__ + "static/media/best_interest_rates_financing.0ce0d91a4104ad5e828ca081c809c9bc.svg";
export { ForwardRef as ReactComponent };